import axios from 'axios';
import * as _ from 'lodash';
import { ROOT_URL, SP_HOST_URL } from './constants';
export const GET_FRONTPAGE_LINKS = 'GET_FRONTPAGE_LINKS';

export async function getFrontpageLinks() {
    const request = await axios.get(`${ROOT_URL}/GetFrontpageLinks${SP_HOST_URL}`, {
        headers: {
            Authorization: localStorage.getItem('id_token'),
        },
    });

    return {
        type: GET_FRONTPAGE_LINKS,
        payload: request,
    };
}